import React from "react";
import { motion } from "framer-motion";
import { connect } from 'react-redux';
import { 
    Row,
    Col,
    Card,
    CardBody
  } from "reactstrap";
import { refreshLogs, pauseLogs } from '../../../redux/actions/admin.action';

const Logs = (props) => {
    return (
            <div className="logsContent">
                <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.2 } }}>
                    <div className="logsBtns">
                        <i className="logsBtn tim-icons icon-refresh-02" onClick={() => props.refreshLogs()}/>
                        <i className={`logsBtn tim-icons ${props.logs?.pause ? 'icon-triangle-right-17' : 'icon-button-pause'}`} onClick={() => props.pauseLogs()}/>
                    </div>
                </motion.div>
                <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                    <Card>
                        <CardBody>
                            <Row className="logLine">
                                <Col md={2} xs={6} className="LogLineBody m-auto text-center">
                                    <div className="logLineData">05/10/2021 20:34</div>
                                </Col>
                                <Col md={2} xs={6} className="logsLine m-auto text-center">
                                    <div className="logsData">React</div>
                                </Col>
                                <Col md={8} xs={12} className="logsLine m-auto">
                                    <div className="logsData">'userName' is assigned a value but never used</div>
                                </Col>
                            </Row>
                            <Row className="logLine">
                                <Col md={2} className="LogLineBody m-auto text-center">
                                    <div className="logLineData">05/10/2021 20:34</div>
                                </Col>
                                <Col md={2} className="logsLine m-auto text-center">
                                    <div className="logsData">React</div>
                                </Col>
                                <Col md={8} className="logsLine m-auto">
                                    <div className="logsData">Line 339:45:   img elements must have an alt prop, either with meaningful text, or an empty string for decorative images  jsx-a11y/alt-text</div>
                                </Col>
                            </Row>
                            <Row className="logLine">
                                <Col md={2} className="LogLineBody m-auto text-center">
                                    <div className="logLineData">05/10/2021 20:34</div>
                                </Col>
                                <Col md={2} className="logsLine m-auto text-center">
                                    <div className="logsData">RustPlusInstance</div>
                                </Col>
                                <Col md={8} className="logsLine m-auto">
                                    <div className="logsData">[server@54.36.124.89:28124] RP instance connected to 54.36.124.89:28124</div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </motion.div>
            </div>
    );
};

const mapDispatchToProps = {
    refreshLogs,
    pauseLogs
};

const mapStateToProps = (state) => {
    const { logs } = state.admin;
    return { logs };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logs);